




















Currency = require 'models/currency.coffee'

module.exports =
  name: 'transaction_current_popover_description'
  components:
    balance: require('components/inside/elements/balance.vue').default
  props: ['transaction', 'mode']
  computed:
    currency_name: ->
      if @$i18n.locale == 'en'
        Currency.get(@currency).name
      else
        Currency.get(@currency).name_ru
    currency: -> @transaction.accountCurrency(@$store.state.user) || @transaction.currency
  watch:
    transaction: -> @focus()
    mode:        -> @focus()
  mounted: ->
    textarea = $(@$el).find('textarea')

    textarea.on 'inserted.atwho', (event, $li, browser_event) =>
      @transaction.description = textarea.val()

    # TODO: enable later, this is for TAGS
    # textarea.atwho
    #   at: "#"
    #   data: @$store.getters.transactions_categories
    textarea.overlay [
      # "@" sign — disabled, because it's not used at all
      # {
      #   match: /\B@\w+/g
      #   css: { 'background-color': '#d8dfea' }
      # }

      {
        match: /#([A-Za-zА-Яа-я0-9ё_]+)/gu
        css: { 'background-color': 'yellow' }
      }
      {
        # /.../g — match all matches
        # (-?\d{1,}\.*) — match numbers, minus sign
        # (?![^\(]*\)) — don't match in brackets
        match: /\b(-?\d{0,}[\.*]?\d{1,})(?![^\(]*\))\b/g
        klasses: 'text-number'
        css: { 'background-color': 'transparent' }
      }
    ]
    @focus()
    # $('#current_transaction_popover').attr('spellcheck', false)
  methods:
    focus: ->
      @transaction.description = @transaction.description.replace(/&amp;/g, '&')
      f = =>
        $textarea = $(@$el).find('textarea').trigger('change')
        $textarea.focus() if !@HM.is_touch
      setTimeout f, 100
